module.exports = __webpack_public_path__ + "static/media/ScrollDown_teal.35c1defb.svg";